import { z } from 'zod'

const chartSpec = z.object({
  type: z.enum(['bar', 'line']),
  title: z.string().trim().min(1).max(120),
  data: z
    .array(z.object({ label: z.string().max(80) }).catchall(z.number()))
    .min(1)
    .max(100)
    .refine((rows) => Object.keys(rows[0] ?? {}).some((key) => key !== 'label'), 'A chart needs at least one numeric series.'),
})

export type ChartSpec = z.infer<typeof chartSpec>

export function parseChartSpec(source: string): ChartSpec | null {
  try {
    return chartSpec.safeParse(JSON.parse(source)).data ?? null
  } catch {
    return null
  }
}
